import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "./Base/baseApiModel";

export const influencerCouponApi = createApi({
    reducerPath: "influencerCouponApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl + "InfluencerCoupon",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("token");
            token && headers.append("Authorization", "Bearer " + token);
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getInfluencerSalesReport: builder.query({
            query: ({ influencerId, startDate, endDate }) => ({
                url: `/sales-report/${influencerId}`,
                method: "GET",
                params: { startDate, endDate }
            })
        })
    })
});

export const { useGetInfluencerSalesReportQuery } = influencerCouponApi;
